<template>
    <div class="box">
        <h2>
            Einstellungen für das KI basierte OCR
        </h2>
        <div class="body">
            <h3 style="margin:0; padding:0;">Vision Prompt</h3>
            <small>Die Einstellungen zum Prompt für die optische Erkennung von Text aus dem PDF.</small>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <textarea v-model="vision_prompt" name="vision_prompt" v-validate="'required'" id="vision_prompt"></textarea>
                <label for="vision_prompt">Vision Prompt</label>
                <span class="error" v-show="errors.has('vision_prompt')">{{ errors.first("vision_prompt") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="vision_tokens" name="vision_tokens" v-validate="'required|numeric'" id="vision_tokens" placeholder=" " type="text" />
                <label for="vision_tokens">Vision Max Tokens</label>
                <span class="error" v-show="errors.has('vision_tokens')">{{ errors.first("vision_tokens") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="vision_temperature" name="vision_temperature" v-validate="'required|decimal'" id="vision_temperature" placeholder=" " type="text" />
                <label for="vision_temperature">Temperature</label>
                <span class="error" v-show="errors.has('vision_temperature')">{{ errors.first("vision_temperature") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="vision_top_k" name="top_k" v-validate="'required|numeric'" id="vision_top_k" placeholder=" " type="text" />
                <label for="vision_top_k">Top K</label>
                <span class="error" v-show="errors.has('vision_top_k')">{{ errors.first("vision_top_k") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="vision_min_p" name="vision_min_p" v-validate="'required|decimal'" id="vision_min_p" placeholder=" " type="text" />
                <label for="vision_min_p">Min P</label>
                <span class="error" v-show="errors.has('vision_min_p')">{{ errors.first("vision_min_p") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="vision_top_p" name="vision_top_p" v-validate="'required|decimal'" id="vision_top_p" placeholder=" " type="text" />
                <label for="vision_top_p">Top P</label>
                <span class="error" v-show="errors.has('vision_top_p')">{{ errors.first("vision_top_p") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="vision_repetition_penalty" name="vision_repetition_penalty" v-validate="'required|decimal'" id="vision_repetition_penalty" placeholder=" " type="text" />
                <label for="vision_repetition_penalty">Repetition Penalty</label>
                <span class="error" v-show="errors.has('vision_repetition_penalty')">{{ errors.first("vision_repetition_penalty") }}</span>
            </div>

            <h3 style="margin:0; padding:0;">Struktur Prompt</h3>
            <small>Der Prompt für die Strukturierung der ausgelesenen Daten als XML. Das XML Schema wird mit "@xml@" eingefügt, der ausgelesene Text mit "@ocr@".</small>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <textarea v-model="struktur_prompt" name="struktur_prompt" v-validate="'required'" id="struktur_prompt"></textarea>
                <label for="struktur_prompt">Struktur Prompt</label>
                <span class="error" v-show="errors.has('struktur_prompt')">{{ errors.first("struktur_prompt") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="struktur_tokens" name="struktur_tokens" v-validate="'required|numeric'" id="struktur_tokens" placeholder=" " type="text" />
                <label for="struktur_tokens">Struktur Max Tokens</label>
                <span class="error" v-show="errors.has('struktur_tokens')">{{ errors.first("struktur_tokens") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="struktur_temperature" name="struktur_temperature" v-validate="'required|decimal'" id="struktur_temperature" placeholder=" " type="text" />
                <label for="struktur_temperature">Temperature</label>
                <span class="error" v-show="errors.has('struktur_temperature')">{{ errors.first("struktur_temperature") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="struktur_top_k" name="top_k" v-validate="'required|numeric'" id="struktur_top_k" placeholder=" " type="text" />
                <label for="struktur_top_k">Top K</label>
                <span class="error" v-show="errors.has('struktur_top_k')">{{ errors.first("struktur_top_k") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="struktur_min_p" name="struktur_min_p" v-validate="'required|decimal'" id="struktur_min_p" placeholder=" " type="text" />
                <label for="struktur_min_p">Min P</label>
                <span class="error" v-show="errors.has('struktur_min_p')">{{ errors.first("struktur_min_p") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="struktur_top_p" name="struktur_top_p" v-validate="'required|decimal'" id="struktur_top_p" placeholder=" " type="text" />
                <label for="struktur_top_p">Top P</label>
                <span class="error" v-show="errors.has('struktur_top_p')">{{ errors.first("struktur_top_p") }}</span>
            </div>
            <div class="form-group form-float no-error" style="margin-bottom: 32px;">
                <input v-model="struktur_repetition_penalty" name="struktur_repetition_penalty" v-validate="'required|decimal'" id="struktur_repetition_penalty" placeholder=" " type="text" />
                <label for="struktur_repetition_penalty">Repetition Penalty</label>
                <span class="error" v-show="errors.has('struktur_repetition_penalty')">{{ errors.first("struktur_repetition_penalty") }}</span>
            </div>
            <hr />
            <div class="button-row">
                <button @click="save()" type="button" class="primary size-l"><i class="fal fa-save"></i> Speichern</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            vision_prompt: "",
            vision_temperature: 0.8,
            vision_top_k: 40,
            vision_min_p: 0.05,
            vision_max_p: 0.95,
            vision_repetition_penalty: 1.1,
            vision_tokens: 20000,

            struktur_prompt: "",
            struktur_temperature: 0.8,
            struktur_top_k: 40,
            struktur_min_p: 0.05,
            struktur_max_p: 0.95,
            struktur_repetition_penalty: 1.1,
            struktur_tokens: 15000
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        save() {
            var settings = {
                vision_prompt: "",
                vision_temperature: 0,
                vision_top_k: 0,
                vision_min_p: 0,
                vision_top_p: 0,
                vision_repetition_penalty: 0,
                vision_tokens: 0,

                struktur_prompt: "",
                struktur_temperature: 0,
                struktur_top_k: 0,
                struktur_min_p: 0,
                struktur_top_p: 0,
                struktur_repetition_penalty: 0,
                struktur_tokens: 0
            };

            settings.vision_prompt = this.vision_prompt;
            settings.vision_temperature = parseFloat(this.vision_temperature);
            settings.vision_top_k = parseInt(this.vision_top_k, 10);
            settings.vision_min_p = parseFloat(this.vision_min_p);
            settings.vision_top_p = parseFloat(this.vision_top_p);
            settings.vision_repetition_penalty = parseFloat(this.vision_repetition_penalty);
            settings.vision_tokens = parseInt(this.vision_tokens, 10);

            settings.struktur_prompt = this.struktur_prompt;
            settings.struktur_temperature = parseFloat(this.struktur_temperature);
            settings.struktur_top_k = parseInt(this.struktur_top_k, 10);
            settings.struktur_min_p = parseFloat(this.struktur_min_p);
            settings.struktur_top_p = parseFloat(this.struktur_top_p);
            settings.struktur_repetition_penalty = parseFloat(this.struktur_repetition_penalty);
            settings.struktur_tokens = parseInt(this.struktur_tokens, 10);

            this.$api.put("/bsv/ki_settings", settings).then(
                () => {
                    this.$snotify.success("Einstellungen gespeichert");
                },
                () => {
                    this.$snotify.error("Speichern fehlgeschlagen");
                }
            );
        },
        fetchData() {
            this.$api.get("/bsv/ki_settings").then(
                response => {
                    if (response.data.data === null) {
                        response.data.data = {
                            vision_prompt: "",
                            vision_temperature: 0.8,
                            vision_top_k: 40,
                            vision_min_p: 0.05,
                            vision_top_p: 0.95,
                            vision_repetition_penalty: 1.1,
                            vision_tokens: 20000,

                            struktur_prompt: "",
                            struktur_temperature: 0.1,
                            struktur_top_k: 40,
                            struktur_min_p: 0.05,
                            struktur_top_p: 0.95,
                            struktur_repetition_penalty: 1.1,
                            struktur_tokens: 15000
                        };
                    }

                    this.vision_prompt = response.data.data.vision_prompt;
                    this.vision_temperature = response.data.data.vision_temperature;
                    this.vision_top_k = response.data.data.vision_top_k;
                    this.vision_min_p = response.data.data.vision_min_p;
                    this.vision_top_p = response.data.data.vision_top_p;
                    this.vision_repetition_penalty = response.data.data.vision_repetition_penalty;
                    this.vision_tokens = response.data.data.vision_tokens;

                    this.struktur_prompt = response.data.data.struktur_prompt;
                    this.struktur_temperature = response.data.data.struktur_temperature;
                    this.struktur_top_k = response.data.data.struktur_top_k;
                    this.struktur_min_p = response.data.data.struktur_min_p;
                    this.struktur_top_p = response.data.data.struktur_top_p;
                    this.struktur_repetition_penalty = response.data.data.struktur_repetition_penalty;
                    this.struktur_tokens = response.data.data.struktur_tokens;
                },
                () => {
                    this.$snotify.error("Fehler beim Laden der Einstellungen");
                }
            );
        }
    }
};
</script>
